<div class="blur-paywall" [ngStyle]="{'min-height': minHeight}">
    <div class="blurred-content">
        <div class="cursor-pointer upgrade-btn d-flex flex-row justify-content-center align-items-center" (click)="onUpgradeClick()">
            <i class="fas fa-lock pr-2"></i>
            <span>{{ message }}</span>
        </div>
    </div>
</div>
